import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Zone } from './zone.model';
import { ZonesModalComponent } from '../components/zones-modal/zones-modal.component';
import { ZoneTranslationModalComponent } from '../components/zone-translation-modal/zone-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ZoneModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openZonesModal(successCallback) {
    const options = {
      width: '900px',
      minHeight: '90vh',
      maxHeight: '90vh',
      disableClose: true,
      position: { top: '5vh' },
      data: {
        title: 'ZONES',
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, ZonesModalComponent);
  }

  openZoneTranslation(zone: Zone, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'ZONE_DETAILS',
        obj: zone,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, ZoneTranslationModalComponent);
  }

  // openZoneInfoModal(item) {
  //   var templateUrl = './app/ajs//modals/zone-info-modal.html';

  //   var modalParams = {
  //     title: 'ZONE_DETAILS',
  //     item: item,
  //   };

  //   WindowModalService.open(templateUrl, modalParams);
  // }
}
